import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ClaimantSelectorComponent } from '../../../core/controls/claimant-selector/claimant-selector.component';

@Component({
  selector: 'app-claimant-option',
  template: `
    <div class="tw-col-span-2 tw-w-full">
      <app-claimant-selector
        [control]="control"
        [contractNumber]="contractNumber"
      />
    </div>
  `,
  styles: ``,
  imports: [ClaimantSelectorComponent],
})
export class ClaimantOptionComponent {
  @Input()
  control: FormControl<any>;

  @Input()
  contractNumber: number;
}
